export default {
  button: {
    cancel: 'Cancel',
    add: 'Add',
    register: 'Register',
    save: 'Save',
    edit: 'Edit',
    login: 'Login',
    logout: 'Logout',
    setting_suru: 'Apply',
    search: 'Search',
    select: 'Select',
    select_via_map: 'Select via map',
    select_via_property_map: 'Select via map',
    move_floor_here: 'Move floor to here',
    move_geofence_here: 'Move geofence to here',
    move_pin_here: 'Move pin to here',
    export_csv: 'CSV Export',
    export_as: 'CSV Export As',
    import_csv: 'CSV Import',
    import: 'Import',
    place_mode: 'Place mode',
    user_mode: 'User mode',
    page_data: 'Page Data',
    click_select: 'Click to select',
    open_video: 'Open Video',
    link: 'Link',
    unlink: 'Unlink',
  },
  breadcrumb: {
    user_info_manage: 'Manage users',
    beacon_info_manage: 'Manage beacons',
    beacon_carried_info_manage: 'Manage beacons carried',
    card_info_manage: 'Manage cards',
    category_info_manage: 'Manage categories',
    floor_info_manage: 'Manage floors',
    user_seach_dashboard: 'Find user location',
  },
  label: {
    mode: 'Mode',
    category_name: 'Category name',
    category_1: 'Category 1',
    category_2: 'Category 2',
    category_3: 'Category 3',
    search_placeholder: 'Search...',
    search_by_placeholder: 'Search By',
    san_id: 'Card ID',
    user_id: 'User ID',
    user: 'User',
    users: 'Users',
    username: 'Name',
    category: 'Category',
    category_id: 'Category ID',
    beacon: 'Beacon',
    beacon_animation: 'Beacon animation',
    card: 'Card',
    card_number: 'Card Number',
    current_floor: 'Current Floor',
    current_location: 'Current Location',
    floor_name: 'Floor Name',
    floor_id: 'Floor ID',
    floor_sw_lat: 'SW Lat',
    floor_sw_lon: 'SW Lon',
    floor_ne_lat: 'NE Lat',
    floor_ne_lon: 'NE Lon',
    floor_angle: 'Floor Edge',
    floor_map_zoom: 'Map Zoom',
    building_name: 'Building Name',
    floor: 'Floor',
    floor_file: 'Floor map',
    csv_file: 'CSV file',
    major: 'Major',
    minor: 'Minor',
    lon: 'Lon',
    lat: 'Lat',
    camera: 'Camera',
    camera_display: 'Camera Video',
    camera_address: 'Camera Address',
    camera_show: 'Show camera',
    camera_tracking: 'Tracking User',
    beacon_uuid: 'Beacon UUID',
    possition: 'Position',
    num_beacon: 'Numof Beacons',
    current_battery: 'Battery',
    announce_heading: 'Announce from Social Area Networks',
    faq_heading: 'Frequently Asked Questions',
    map_adjust: 'Map Adjust',
    map_adjust_parameters: 'Map Adjust Parameters',
    search_card_info: 'Search card information',
    search_beacon_info: 'Search beacon information',
    search_category_info: 'Search category information',
    search_user_info: 'Search user information',
    search_floor_info: 'Search floor information',
    search_sanid_info: 'Search San ID information',
    refresh_location_time: 'Auto Screen Refresh [sec] ',
    card_off_after_minutes: 'Hide card after [minute] ',
    minimum_number_locations: 'Minimum number of locations [number]',
    gps_error_acceptable_rank: 'GPS Error Acceptable Range [m] ',
    csv_columns_format: 'CSV columns format',
    floor_opacity: 'Floor transparent',
    last_updated: 'Last Updated',
    gps_mode: 'GPS',
    gps_ok: 'GPS OK',
    gps_ng: 'GPS NG',
    beacon_ng: 'Beacon NG',
    status: 'Status',
    color: 'Color',
    type: 'Type',
    people: 'People',
    things: 'Things',
    location: 'Location',
    analysis_chart_title: '',
    positioning: 'Positioning...',
    arrived_at: 'Arrived at',
    entered_at: 'Enter at',
    leaveded_at: 'Leave at',
    score: 'Score',
    pan_id: 'Pan ID',
    jbox_type: 'JBox Type',
    date_slot: 'Slot',
    outside_title: 'Outside',
    outside_floor: 'Outside',
    mobile_username: 'Mobile username',
    password: 'Password',
    device: 'Device',
    place: 'Place',
    remaining_qty: 'Qty',
    time: 'Time',
    detail: 'Detail',
    sensor: 'Sensor',
    collapse_detail: 'Collapse Detail',
    dripnavi_normal: 'NORMAL',
    dripnavi_low: 'LOW',
    dripnavi_high: 'HIGH',
    dripnavi_no: 'NO FLOW',
    jcard: 'JCard',
    smart_jcard: 'Smart JCard',
    press_to_add: 'Choose by click or press enter',
    press_to_remove: 'Remove by click or press enter',
    press_to_selectAll: 'Choose all by click or press enter',
    press_to_unselectAll: 'Remove all by click or press enter',
    placeholder_tag: 'Add this as new tag',
    selected: 'Selected',
    select_users: 'Users',
    select_actions: 'Actions',
    select_bg_colors: 'Background Messages Color',
    select_range_date: 'Select Range',
    from_yesterday: 'From yesterday',
    from_one_week: 'From 1 week',
    from_one_month: 'From 1 month',
    geofence_name: 'Geofence Name',
    geofence: 'Geofence',
    single: 'Single',
    multiple: 'Multiple',
    read: 'Read',
    unread: 'UnRead',
    ok: 'OK',
    see_history_tracking: 'See history tracking of {user}',
    history_tracking: 'History Tracking',
    selecte_user_tracking: 'Select User Tracking',
    exit: 'Exit',
    enter: 'Enter',
    action: 'Actions',
    email: 'Email',
    recipients: 'Recipients',
    in: 'IN',
    out: 'OUT',
    messages: 'Messages',
    target: 'Target',
    patient: 'Patient',
    auto_exit_detect: 'Auto Exit',
    feature: 'Feature',
    width: 'Width',
    height: 'Height',
    order: 'Order',
    full: 'Full',
    user_type: 'User Type',
    filter_text: 'Filter Text',
    all: 'All Types',
    name: 'Name',
    widget_setting: 'Dashboard Widgets Setting',
    internal_settings: 'Internal Settings',
    personal_settings: 'Personal settings',
    link: 'Link',
    env_information: 'Enviroment Information',
    mitsuiwa_beacon: 'Mitsuiwa Beacon',
    optional_feature: 'Optional feature',
    drip_navi: 'DripNavi',
  },
  menu: {
    viewer: 'VIEWER',
    dashboard: 'Dashboard',
    user_search: 'User Search',
    link: 'Link',
    manage: 'MANAGE',
    system_menu: 'System Menu',
    indoor_map: 'Indoor Map',
    outdoor_map: 'Outdoor Map',
    work_recorder: 'Charts',
    time_line: 'Work Recorder',
    stamp_rally: 'Stamp Rally',
    geofences: 'Geofences',
    geofence_monitor: 'Geofence Monitor',
    notification: 'Notification',
    manage_category: 'CATEGORIES',
    manage_carried_device: 'CARRIED DEVICES',
    manage_fixed_device: 'FIXED DEVICES',
    manage_card: 'CARDS',
    manage_card_gateway: 'BEACON SCANNERS',
    manage_beacon: 'BEACONS',
    manage_floor: 'FLOORS',
    manage_user: 'USERS',
    system_setting: 'System Setting',
    notification_setting: 'Notification Settings',
  },
  messages: {
    data_not_found: 'Data not found!',
    user_not_found: 'User not found!',
    unit_required: 'Unit is required.',
    username_required: 'Username is required.',
    password_required: 'Password is required.',
    drop_file_here_or_select_a_file: 'Drop a file here or select a file.',
    are_you_sure_want_to_delete: 'Are you sure to delete this item?',
    has_refs_data_are_you_sure_want_to_delete: 'This item have related information. Continue to delete it?',
    save_success: 'Data stored successfully.',
    update_success: 'Data updated successfully.',
    delete_success: 'Data deleted successfully.',
    field_is_required: 'This field is required.',
    major_minor_is_required_and_unique: 'Major/Minor is required and unique.',
    location_not_found: 'Location not found.',
    floor_not_found: 'Floor not found.',
    user_just_go_out: '{username} just go to outside.',
    user_just_goto_floor_x: '{username} just moved to "{location}".',
    card_off_after_minutes_desc: 'Card will be hidden if N minute(s) no data sent.',
    minimum_number_locations_desc: 'Number of records in location for action (send mail is available geofence now).',
    download_prepare: 'Your download is preparing, please wait!',
    download_ready: 'Data is ready, zip file is in progress',
    download_success: 'Successfully downloaded.',
    download_error: 'Something wrong happened. Blank can not be convert.',
    device_ip_invalid: 'This IP address invalid!',
    san_ids_warning: '*If {deviceId} does not exist in JBOX server, it will not be added.',
    san_ids_error: 'Those {deviceId}s do not exist in JBOX server. Please check it and import again.',
    unit_deactivate: 'This unit has been deactivated, you can only view old data.',
    go_inside_floor: 'The user goes to another room in floor',
    go_outside_floor: 'The user goes out of the floor',
    user_appeared_once: 'This user appear and leave immediately afterwards!',
    beacon_off: 'Beacon off',
    beacon_recovery: 'Beacon recovery',
    beacon_failure_position: 'Beacon positioning failure',
    beacon_recovery_position: 'Beacon positioning recovery',
    location_failure_gps: 'GPS positioning failure',
    location_position_gps: 'GPS positioning recovery',
    invalid_email: 'This field has invalid email',
    field_is_greater_than: 'This field must be greater than {number}.',
  },
  pagination: {
    per_page: 'per page',
    of_pages: 'of page(s)',
  },
  type: {
    day: 'Day',
    range: 'Range',
  },
  placeholder: {
    ip_address: 'http://192.168.0.1:8080/path?param=value',
    input_filter: 'Enter text to filter',
    input_order: 'Enter ordinal number',
  },
  widget_setting: {
    user_search: 'User Search',
    indoor: 'Indoor Map',
    outdoor: 'Outdoor Map',
  },
  all: 'All',
  delete: 'Delete',
  UUID: 'UUID',
  total_score: 'Total score',
}
